<template>
  <div
    class="xs12"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div
          class="overline mb-4"
          v-text="`Cooperativa Coopermais`"
        />
        <v-list-item-title
          class="headline font-weight-medium mb-1"
          v-text="title"
        />
        <v-list-item-subtitle
          class="font-weight-medium"
          v-text="$route.meta.title"
        />
      </v-list-item-content>
      <v-list-item-avatar
        tile
        size="100"
      >
        <v-img
          :src="this.$options.filters.generateLogoURI($route.meta.isIndustry)"
          contain
        />
      </v-list-item-avatar>
    </v-list-item>
    <v-list-item dense>
      <v-list-item-content>
        <v-list-item-subtitle
          class="font-weight-bold"
          v-text="($route.meta.isOpcionalValue && !zeroValue) ? Message['registro'](filterReport(this.relatorio)) : Message['registro'](this.relatorio.length)"
        />
        <v-list-item-subtitle
          v-if="$route.meta.isShowSumValue"
          class="font-weight-regular"
          v-text="Message[$route.meta.sumValueType]($route.meta.showSumValue(this.relatorio))"
        />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Message from '@/plugins/message'
export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      Message
    }
  },
  computed: {
    ...mapGetters(['relatorio', 'zeroValue'])
  },
  methods: {
    filterReport (items) {
      return items.filter((item) => this.$route.meta.opcionalCondition(item)).length
    }
  }
}
</script>
